import $ from 'jquery';
import { orderBy } from 'lodash';
import { triggerStateChangedRequest } from '~core';
import Pickr from '@simonwep/pickr/dist/pickr.es5.min';
import '@simonwep/pickr/dist/themes/monolith.min.css';

const createColorPicker = (id, initialHexColor, object, property, parent) => {
  const el = document.querySelector(`#color-picker-${id}`);
  if (!el) return; // container not available yet
  const pickr = Pickr.create({
    el,

    theme: 'monolith',

    comparison: false,

    default: initialHexColor,

    swatches: [
      'rgba(0,0,0, 1)',
      'rgba(130,130,130, 1)',
      'rgba(255,255,255, 1)',
      'rgba(255,255,255, 0)',
      'rgba(188,160,76, 1)',
      'rgba(148,23,81, 1)',
      'rgba(224,41,17, 1)',
      'rgba(255,147,0, 1)',
      'rgba(255,252,121, 1)',
      'rgba(79,143,0, 1)',
      'rgba(0,145,147, 1)',
      'rgba(0,84,147, 1)',
      'rgba(4,51,255, 1)',
      'rgba(131,68,204, 1)',
    ],

    components: {
      // Main components
      preview: true,
      opacity: true,
      hue: true,

      // Input / output Options
      interaction: {
        input: true,
      },
    },
  });

  pickr.on('change', (color) => {
    const hex = `#${color.toHEXA().join('').toUpperCase()}`;

    if (property === 'fill') {
      object.set({
        fill: hex,
      });
    } else if (property === 'stroke') {
      object.set({
        stroke: hex,
      });
    } else if (property === 'colorStop') {
      object.color = hex;
      object.opacity = color.toRGBA()[3];
      parent.set({ dirty: true });
    }

    window.canvas.renderAll();
    triggerStateChangedRequest();
  });
};

const rgbToRgba = (rgb, opacity = 1) => {
  if (!rgb.startsWith('rgb(')) {
    return rgb;
  }
  const [r, g, b] = rgb
    .replace(/^rgb\(/i, '')
    .replace(/$\)/i, '')
    .replace(/ /, '')
    .split(',');

  const rgba = `rgba(${[r, g, b, opacity].join(',')})`;

  return rgba;
};

export const handleSvgColors = () => {
  const selection = window.canvas.getActiveObject();

  // Recursively collect vector primitives from groups
  const collected = [];
  const flatten = (obj) => {
    if (!obj) return;
    if (typeof obj.getObjects === 'function') {
      const children = obj.getObjects();
      children && children.forEach(flatten);
    } else {
      collected.push(obj);
    }
  };

  if (selection && typeof selection.getObjects === 'function') {
    flatten(selection);
  } else if (selection) {
    collected.push(selection);
  }

  if ($('.svg-colors').length === 0) {
    // No container exists (e.g., floating panel not yet rendered). Skip.
    return;
  }
  $('.svg-colors').empty();
  const colors = [];
  const allowedTypes = [
    'path',
    'rect',
    'circle',
    'ellipse',
    'polygon',
    'polyline',
    'line',
  ];

  collected.forEach((object) => {
    if (!allowedTypes.includes(object.type)) {
      return;
    }

    if (
      object.fill !== null &&
      typeof object.fill === 'object' &&
      object.fill.colorStops
    ) {
      for (const colorStop of orderBy(object.fill.colorStops, 'offset')) {
        colors.push({
          id: colorStop.id,
          hex: colorStop.color || 'rgba(255,255,255, 0.0)',
          object: colorStop,
          parent: object,
          property: 'colorStop',
        });
      }
    } else if (typeof object.fill === 'string' && object.fill !== '') {
      colors.push({
        id: object.id,
        hex: object.fill || 'rgba(255,255,255, 0.0)',
        object: object,
        property: 'fill',
      });
    }

    if (
      object.stroke !== null &&
      typeof object.stroke === 'object' &&
      object.stroke.colorStops
    ) {
      for (const colorStop of object.stroke.colorStops) {
        colors.push({
          id: colorStop.id,
          hex:
            rgbToRgba(colorStop.color, colorStop.opacity) ||
            'rgba(255,255,255, 0.0)',
          object: colorStop,
          parent: object,
          property: 'colorStop',
        });
      }
    } else if (typeof object.stroke === 'string' && object.stroke !== '') {
      colors.push({
        id: object.id,
        hex: object.stroke || 'rgba(255,255,255, 0.0)',
        object: object,
        property: 'stroke',
      });
    }
  });

  if (colors.length > 15) {
    console.log('Too many SVG color, skipping pickers', colors.length);
    return;
  }

  for (const color of colors) {
    $('.svg-colors').append(`<div id="color-picker-${color.id}"></div>`);
    createColorPicker(
      color.id,
      color.hex,
      color.object,
      color.property,
      color.parent
    );
  }
};
